import { useEffect } from "react";
import { getActivities } from "../api";
import { useNavigate } from "react-router-dom";

export default function Activities(props) {

    const { activities, setActivities, loggedIn, setMakeActivity, setActivityId, setFromActivities} = props;

    const navigate = useNavigate()

    const fetchActivities = async () => {
        try {
            const result = await getActivities();
            setActivities(result);
        } catch (err) {
            console.error("Failed to fetch activities", err);
        }   
    };

    

    useEffect(() => {
        fetchActivities();
    }, []);

    return (
        <>
        {loggedIn ? <button type="button" className="createButton" onClick={((event) => {
                    event.preventDefault;
                    setMakeActivity(true)
            })}>Create New Activity</button>
        : null}
        <div className="activitiesDiv">
            {
                activities.map((activity) => {
                    return <div key={activity.id} className="activities">
                        <div className="routineUsername" onClick={((event) => {
                                        event.preventDefault;
                                        setActivityId(activity.id);
                                        setFromActivities(true);
                                        navigate("../routines");
                                    })}>Name: {activity.name}</div>
                        <div>Description: {activity.description}</div>
                    </div>
                })
            }
        </div>
        </>
    )
};